import ProjectsContainer from './ProjectsContainer'

export default ProjectsContainer
